import { Directive } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator
} from '@angular/forms';

export const URL_REGEXP = new RegExp(
  /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
  'g'
);

export function isValidUrl(url: string): boolean {
  return !!url.match(URL_REGEXP);
}

export function validateUrl(control: AbstractControl): ValidationErrors | null {
  return !control.value || isValidUrl(control.value)
    ? null
    : { url: 'Invalid URL' };
}

@Directive({
  selector: '[elmValidateUrl]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ElmValidateUrlDirective,
      multi: true
    }
  ]
})
export class ElmValidateUrlDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return validateUrl(control);
  }
}
